import React from "react";
import PropTypes from "prop-types";

import GBStdChart from "../../../Library/Charts/GBStdChart";
import GBStdTable from "../../../Library/Tables/GBStdTable";
//import GBStdTable from "../../../Library/Tables/GBStdTableAG/GbStdTable";
import TRadioGroup from "../../../Library/RadioGroups/TRadioGroup";
import TLabel from "../../../Library/Labels/TLabel";
import TButton from "../../../Library/Buttons/TButton";
import TComboBox from "../../../Library/ComboBoxes/TComboBox";
import TDialog from "../../../Library/Dialogs/TDialog";
import TWifiAnimation from "../../../Library/OtherComponents/TWifiAnimation";

import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import * as SCConst from "../NonComponents/SCConst";
import {
    getResultName,
    getResultNumInds,
    canShowGraphAsBar,
    isTimeType1StdRes,
    isDualAxesStdRes,
} from "../NonComponents/SCDataUtil";
import { getFinalPossibleYear, getMonthYearComboBoxIdx, getFinalPossibleMonth } from "../NonComponents/SCUtil";

class SCResultsForm extends React.Component {
    static propTypes = {
        processingServerCall: PropTypes.bool,
        config: PropTypes.object,
        configExtra: PropTypes.object,
        onConfigChange: PropTypes.func,
        displayOL: PropTypes.arrayOf(PropTypes.object),
        mstIDsObj: PropTypes.object,
        indInfo: PropTypes.object,
        packChart: PropTypes.object,
        packTable: PropTypes.object,
    };

    static defaultProps = {
        processingServerCall: false,
        config: {},
        configExtra: {},
        onConfigChange: () => console.log("onConfigChange"),
        displayOL: [],
        mstIDsObj: null,
        indInfo: null,
        packChart: {},
        packTable: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            retrievingResultsBool: false,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onConfigChangeResultsForm = (newConfig, newConfigExtra) => {
        try {
            this.setState(
                {
                    retrievingResultsBool: true,
                },
                () => {
                    this.props.onConfigChange(newConfig, newConfigExtra, () => {
                        this.setState({
                            retrievingResultsBool: false,
                        });
                    });
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onPrevBtnClick = () => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const timeInterval = config[SCConst.timeInterval];
            const year = config[SCConst.year];
            const half = config[SCConst.half];
            const quarter = config[SCConst.quarter];
            const month = config[SCConst.month];

            /* Time period traversal only makes sense under the aggregate graph view type. */
            const timeIntervalAggr = timeInterval[SCConst.aggregateView];

            if (timeIntervalAggr === SCConst.monthly) {
                if (month > 1) {
                    config[SCConst.month] = month - 1;
                } else {
                    config[SCConst.month] = 12;
                    config[SCConst.year] = year - 1;
                }
            } else if (timeIntervalAggr === SCConst.quarterly) {
                if (quarter > 1) {
                    config[SCConst.quarter] = quarter - 1;
                } else {
                    config[SCConst.quarter] = 4;
                    config[SCConst.year] = year - 1;
                }
            } else if (timeIntervalAggr === SCConst.biAnnually) {
                if (half > 1) {
                    config[SCConst.half] = half - 1;
                } else {
                    config[SCConst.half] = 2;
                    config[SCConst.year] = year - 1;
                }
            } else if (timeIntervalAggr === SCConst.annually) {
                if (year > SCConst.firstPossibleYear) {
                    config[SCConst.year] = year - 1;
                }
            }

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onNextBtnClick = () => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const timeInterval = config[SCConst.timeInterval];
            const year = config[SCConst.year];
            const half = config[SCConst.half];
            const quarter = config[SCConst.quarter];
            const month = config[SCConst.month];

            /* Time period traversal only makes sense under the aggregate graph view type. */
            const timeIntervalAggr = timeInterval[SCConst.aggregateView];

            if (timeIntervalAggr === SCConst.monthly) {
                if (month < 12) {
                    config[SCConst.month] = month + 1;
                } else {
                    config[SCConst.month] = 1;
                    config[SCConst.year] = year + 1;
                }
            } else if (timeIntervalAggr === SCConst.quarterly) {
                if (quarter < 4) {
                    config[SCConst.quarter] = quarter + 1;
                } else {
                    config[SCConst.quarter] = 1;
                    config[SCConst.year] = year + 1;
                }
            } else if (timeIntervalAggr === SCConst.biAnnually) {
                if (half < 2) {
                    config[SCConst.half] = half + 1;
                } else {
                    config[SCConst.half] = 1;
                    config[SCConst.year] = year + 1;
                }
            } else if (timeIntervalAggr === SCConst.annually) {
                let d = new Date();

                if (year < d.getFullYear()) {
                    config[SCConst.year] = year + 1;
                }
            }

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onChartTypeRadioChange = (value, info) => {
        try {
            const config = JSON.parse(JSON.stringify(this.props.config));
            let configExtra = JSON.parse(JSON.stringify(this.props.configExtra));

            configExtra[SCConst.chartTypeClient] = info[0];

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onGraphViewRadioChange = (value, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            let configExtra = JSON.parse(JSON.stringify(this.props.configExtra));

            config[SCConst.graphViewType] = info[0];

            /* If we just switched to trend, default the chart type to bar, since it
               can't be a line or table. */
            if (config[SCConst.graphViewType] === SCConst.trendView) {
                configExtra[SCConst.chartTypeClient] = SCConst.bar;
            }

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onXAxisVarRadioChange = (value, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            let configExtra = JSON.parse(JSON.stringify(this.props.configExtra));

            config[SCConst.xAxisVar] = info[0];

            /* If we just switched to level, default the chart type to bar, since it can't be a line. */
            if (config[SCConst.xAxisVar] === SCConst.xAxisLevel) {
                configExtra.chartTypeClient = SCConst.bar;
            }

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDemandCreationRadioChange = (value, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));

            config[SCConst.demandCreationAgeGrp] = info[0];

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* Time type 2 (aggregate): For these results. the user selects a timeframe
       (ex: Feb 2015 to Jan 2017), and we display the graph over this timeframe
       (no buttons under graph for traversing). Get all information from
       third paramter, info. We don't care about the selected combobox index (value)
       or text at the selected combobox index.

       ex:

       value : 109
       text  : Feb 2019
       info  : ["timeIntervalValsAggr", 1, 2, 2019]
    */
    onComboboxChangeTimeType2Aggr = (value, text, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const period = info[0]; // first (1) or final (2) period
            const month = info[1]; // month (1-12)
            const year = info[2]; // year (2010-current year)

            config[SCConst.timeIntervalValsAggr][SCConst.monthly][period] = month;
            config[SCConst.timeIntervalValsAggr][SCConst.annually][period] = year;

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* Time type 3 (trend), first year */
    onFirstYearTrendComboboxChange = (value, text, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const year = info[0]; // year (2010-current year)

            config[SCConst.firstYearTrend] = year;

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* Time type 3 (trend), final year */
    onFinalYearTrendComboboxChange = (value, text, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const year = info[0]; // year (2010-current year)

            config[SCConst.finalYearTrend] = year;

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onTimeIntervalComboBoxChange = (value, text, info) => {
        try {
            let config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const timeInterval = info[0]; // monthly/quarterly/biannually/annually

            /* As of Apr 2019, the user can only change the time interval for the
               trend view. The aggregate view time interval will be fixed to monthly. */
            config[SCConst.timeInterval][SCConst.trendView] = timeInterval;

            this.onConfigChangeResultsForm(config, configExtra);
            //this.props.onConfigChange(config, configExtra);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            /* State */
            const retrievingResultsBool = this.state.retrievingResultsBool;

            /* Get main objects from props. */

            const config = JSON.parse(JSON.stringify(this.props.config));
            const configExtra = JSON.parse(JSON.stringify(this.props.configExtra));
            const displayOL = this.props.displayOL;
            const mstIDsObj = this.props.mstIDsObj;
            const indInfo = this.props.indInfo;
            const packChart = this.props.packChart;
            const packTable = this.props.packTable;

            /* Abbr. config fields */

            const graphViewType = config[SCConst.graphViewType];
            const xAxisVar = config[SCConst.xAxisVar];
            const indsIncluded = config[SCConst.indsIncluded];
            const timeInterval = config[SCConst.timeInterval];
            const month = config[SCConst.month];
            const quarter = config[SCConst.quarter];
            const half = config[SCConst.half];
            const year = config[SCConst.year];
            const demandCreationAgeGrp = config[SCConst.demandCreationAgeGrp];

            /* Abbr. configExtra fields */

            const chartTypeClient = configExtra.chartTypeClient;
            const resultPlotType = configExtra.resultPlotType;
            const stdResID = configExtra.stdResID;

            /* Abbr. mstIDsObj fields */

            const stdResultMstIDs = mstIDsObj[SCConst.stdResultMstIDs];

            /* Abbr. indInfo fields */

            const numItemsPerInd = indInfo[SCConst.numItemsPerInd];

            /* Styles */

            const styles = SCConst.styles;

            /* Components */

            let tableTitleDiv = null;
            let chartOrTable = null;
            let tooManySitesToShowLab = null;
            let prevBtn = null;
            let nextBtn = null;
            let graphViewRadioGroupHeader = null;
            let graphViewRadioGroup = null;
            let timeIntervalComboBox = null;
            let firstMonthYearComboBox = null;
            let finalMonthYearComboBox = null;
            let firstYearTrendComboBox = null;
            let finalYearTrendComboBox = null;
            let chartTypeRadioGroupHeader = null;
            let chartTypeRadioGroup = null;
            let demandCreationAgeGroupHeader = null;
            let demandCreationAgeGroup = null;
            let xAxisVarDiv = null;

            /* General variables */

            let prevBtnStr = "";
            let nextBtnStr = "";
            let itemIdx = 0;
            let chartTypeItems = [];
            let chartTypeInfo = [];
            let numOptions = 0;
            let chartType = "line";
            const comboBoxWidth = "125px";
            const timeIntervalAggr = timeInterval[SCConst.aggregateView];
            const timeIntervalTrend = timeInterval[SCConst.trendView];

            const showingOneIndicator =
                (resultPlotType === SCConst.flexiblePlotType &&
                    indsIncluded.length === 2 &&
                    numItemsPerInd[indsIncluded[1]] === 1) ||
                (resultPlotType === SCConst.standardPlotType && getResultNumInds(displayOL, stdResID) === 1);

            /* The graph view radio group can only be shown if exactly one indicator
               (either custom or standard; doesn't matter) is being shown. All results
               can be shown as an aggregate graph but only ones showing exactly one
               indicator can be shown as a trend graph.

               If the user selects trend as an option, we can't give them the option of
               choosing an x-axis variable  (it will always show time on the x-axis for trend).
               The user can only view bars for trend as well, so we can't show the chart type either.

               What we do need to show if trend is selected are an interval radio group and
               first and final year comboboxes. */
            if (showingOneIndicator) {
                graphViewRadioGroupHeader = <h5>View</h5>;

                graphViewRadioGroup = (
                    <TRadioGroup
                        itemIndex={graphViewType - 1}
                        items={["Trend", "Aggregate"]}
                        handleChange={this.onGraphViewRadioChange}
                        info={[[SCConst.trendView], [SCConst.aggregateView]]}
                        row={true}
                    />
                );
            }

            if (graphViewType === SCConst.aggregateView) {
                //if ((graphViewType === SCConst.aggregateView) || (!showingOneIndicator)) {
                const months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
                let monthYearStrings = [];
                let monthYearInfo = [];
                let finalPossibleMonth;
                const finalPossibleYear = getFinalPossibleYear();

                for (let y = SCConst.firstPossibleYear; y <= finalPossibleYear; y++) {
                    finalPossibleMonth = getFinalPossibleMonth(y);

                    for (let m = 1; m <= finalPossibleMonth; m++) {
                        monthYearStrings.push(months[m - 1] + " " + y.toString());
                        monthYearInfo.push([SCConst.firstPeriod, m, y]);
                    }
                }

                const selectedFirstMonth = config[SCConst.timeIntervalValsAggr][SCConst.monthly][SCConst.firstPeriod];
                const selectedFirstYear = config[SCConst.timeIntervalValsAggr][SCConst.annually][SCConst.firstPeriod];
                const firstMonthYearComboBoxIdx = getMonthYearComboBoxIdx(selectedFirstMonth, selectedFirstYear);

                firstMonthYearComboBox = (
                    <TComboBox
                        caption="First month"
                        width={"125px"}
                        items={monthYearStrings}
                        // style={styles.combobox}
                        itemIndex={firstMonthYearComboBoxIdx}
                        onChange={this.onComboboxChangeTimeType2Aggr}
                        info={monthYearInfo}
                    />
                );

                monthYearInfo = [];
                for (let y = SCConst.firstPossibleYear; y <= finalPossibleYear; y++) {
                    finalPossibleMonth = getFinalPossibleMonth(y);

                    for (let m = 1; m <= finalPossibleMonth; m++) {
                        monthYearInfo.push([SCConst.finalPeriod, m, y]);
                    }
                }

                const selectedFinalMonth = config[SCConst.timeIntervalValsAggr][SCConst.monthly][SCConst.finalPeriod];
                const selectedFinalYear = config[SCConst.timeIntervalValsAggr][SCConst.annually][SCConst.finalPeriod];
                const finalMonthYearComboBoxIdx = getMonthYearComboBoxIdx(selectedFinalMonth, selectedFinalYear);

                finalMonthYearComboBox = (
                    <TComboBox
                        caption="Final month"
                        width={comboBoxWidth}
                        items={monthYearStrings}
                        // style={styles.combobox}
                        itemIndex={finalMonthYearComboBoxIdx}
                        onChange={this.onComboboxChangeTimeType2Aggr}
                        info={monthYearInfo}
                    />
                );
            } else {
                timeIntervalComboBox = (
                    <TComboBox
                        caption="Time interval"
                        width={comboBoxWidth}
                        items={["Month", "Quarter", "Half-Year", "Year"]}
                        // style={styles.combobox}
                        itemIndex={timeIntervalTrend - 1}
                        onChange={this.onTimeIntervalComboBoxChange}
                        info={[[SCConst.monthly], [SCConst.quarterly], [SCConst.biAnnually], [SCConst.annually]]}
                    />
                );

                let years = [];
                let firstYearInfo = [];
                let finalYearInfo = [];
                const finalPossibleYear = getFinalPossibleYear();
                for (let y = SCConst.firstPossibleYear; y <= finalPossibleYear; y++) {
                    years.push(y.toString());
                    firstYearInfo.push([y]);
                    finalYearInfo.push([y]);
                }
                const firstYearTrendComboBoxIdx = config[SCConst.firstYearTrend] - SCConst.firstPossibleYear;

                firstYearTrendComboBox = (
                    <TComboBox
                        caption="First year"
                        width={comboBoxWidth}
                        items={years}
                        // style={styles.combobox}
                        itemIndex={firstYearTrendComboBoxIdx}
                        onChange={this.onFirstYearTrendComboboxChange}
                        info={firstYearInfo}
                    />
                );

                const finalYearTrendComboBoxIdx = config[SCConst.finalYearTrend] - SCConst.firstPossibleYear;

                finalYearTrendComboBox = (
                    <TComboBox
                        caption="Final year"
                        width={comboBoxWidth}
                        items={years}
                        // style={styles.combobox}
                        itemIndex={finalYearTrendComboBoxIdx}
                        onChange={this.onFinalYearTrendComboboxChange}
                        info={finalYearInfo}
                    />
                );
            }

            const resultName = getResultName(displayOL, configExtra.stdResID);

            if (chartTypeClient === SCConst.bar) {
                chartType = "column";
            } else if (chartTypeClient === SCConst.table) {
                chartType = "table";
            }

            /* Set up table-related Components if user selects table. */
            if (chartTypeClient === SCConst.table) {
                if (resultPlotType === SCConst.flexiblePlotType) {
                    tableTitleDiv = (
                        <div>
                            <TLabel
                                caption={"Custom"}
                                style={styles.label}
                            />
                        </div>
                    );
                } else {
                    tableTitleDiv = (
                        <div>
                            <TLabel
                                caption={resultName}
                                style={styles.label}
                            />
                        </div>
                    );
                }

                chartOrTable = (
                    <GBStdTable
                        id="MyTable"
                        minHeight={500}
                        maxHeight={500}
                        packTable={packTable}
                        disableContextMenu={true}
                    />
                );

                // search markChange to find places where you made GBStdTable "work". Although you get a table, it's
                // all kinds of messed up...
                // chartOrTable =
                //     <GBStdTable
                //         id                 = "MyTable"
                //         //minHeight          = {500}
                //         //maxHeight          = {500}
                //         packTable          = {packTable}
                //         onPackTableChanged = {() => {}}
                //         //disableContextMenu = {true}
                //     />;
            } else {
            /* Otherwise, set up chart-related Components. */
                /* If there are over 255 of anything to show, tell the user we can't show them all and they will have
                   to refine their options. */
                if (packChart.numSubsets === 255 || packChart.numPoints === 255) {
                    tooManySitesToShowLab = (
                        <h5>
                            Note: There are more locations or time periods matching your selected options than can be
                            shown.
                        </h5>
                    );
                }

                chartOrTable = (
                    <GBStdChart
                        id="MyChart"
                        minHeight={500}
                        maxHeight={500}
                        packChart={packChart}
                        chartType={chartType}
                        showLegend={packChart.showLegend}
                    />
                );

                if (resultPlotType === SCConst.flexiblePlotType) {
                    /* Time can only be selected if exactly one indicator is chosen. */
                    if (!showingOneIndicator) {
                        xAxisVarDiv = (
                            <div>
                                <h5>X-axis variable</h5>
                                <TRadioGroup
                                    itemIndex={xAxisVar - 1}
                                    items={["Level"]}
                                    handleChange={this.onXAxisVarRadioChange}
                                    info={[[SCConst.xAxisLevel]]}
                                    row={true}
                                />
                            </div>
                        );
                    } else if (graphViewType !== SCConst.trendView) {
                        xAxisVarDiv = (
                            <div>
                                <h5>X-axis variable</h5>
                                <TRadioGroup
                                    itemIndex={xAxisVar - 1}
                                    items={["Level", "Time"]}
                                    handleChange={this.onXAxisVarRadioChange}
                                    info={[[SCConst.xAxisLevel], [SCConst.xAxisTime]]}
                                    row={true}
                                />
                            </div>
                        );
                    }
                }
                /* If we are showing one of several specific standard results as something other than a table,
                   then create previous and next buttons to navigate through the time intervals. */

                if (resultPlotType === SCConst.standardPlotType && isTimeType1StdRes(displayOL, mstIDsObj, stdResID)) {
                    let prevBtnDisabled = false;
                    let nextBtnDisabled = false;

                    if (timeIntervalAggr === SCConst.annually) {
                        prevBtnStr = "Previous year";
                        nextBtnStr = "Next year";

                        if (year === SCConst.firstPossibleYear) {
                            prevBtnDisabled = true;
                        } else if (year === getFinalPossibleYear()) {
                            nextBtnDisabled = true;
                        }
                    } else if (timeIntervalAggr === SCConst.biAnnually) {
                        prevBtnStr = "Previous half";
                        nextBtnStr = "Next half";

                        if (half === 1 && year === SCConst.firstPossibleYear) {
                            prevBtnDisabled = true;
                        } else if (half === 2 && year === getFinalPossibleYear()) {
                            nextBtnDisabled = true;
                        }
                    } else if (timeIntervalAggr === SCConst.quarterly) {
                        prevBtnStr = "Previous quarter";
                        nextBtnStr = "Next quarter";

                        if (quarter === 1 && year === SCConst.firstPossibleYear) {
                            prevBtnDisabled = true;
                        } else if (quarter === 4 && year === getFinalPossibleYear()) {
                            nextBtnDisabled = true;
                        }
                    } else if (timeIntervalAggr === SCConst.monthly) {
                        prevBtnStr = "Previous month";
                        nextBtnStr = "Next month";

                        if (month === 1 && year === SCConst.firstPossibleYear) {
                            prevBtnDisabled = true;
                        } else if (month === 12 && year === getFinalPossibleYear()) {
                            nextBtnDisabled = true;
                        }
                    }

                    prevBtn = (
                        <TButton
                            caption={prevBtnStr}
                            onClick={this.onPrevBtnClick}
                            disabled={prevBtnDisabled}
                        />
                    );

                    nextBtn = (
                        <TButton
                            caption={nextBtnStr}
                            onClick={this.onNextBtnClick}
                            disabled={nextBtnDisabled}
                        />
                    );
                }

                if (stdResultMstIDs[stdResID] === SCConst.demandCreationResMstID) {
                    demandCreationAgeGroup = (
                        <TRadioGroup
                            itemIndex={demandCreationAgeGrp - 1}
                            items={["Under 15", "15+", "All ages"]}
                            handleChange={this.onDemandCreationRadioChange}
                            info={[[SCConst.LT15DC], [SCConst.ageGroupPlusDC], [SCConst.allAgesDC]]}
                            row={true}
                        />
                    );
                    demandCreationAgeGroupHeader = <h5>Age group options</h5>;
                }
            }

            if (graphViewType !== SCConst.trendView) {
                chartTypeRadioGroupHeader = <h5>Chart type</h5>;

                if (!isDualAxesStdRes(displayOL, mstIDsObj, stdResID)) {
                    // commented out for now because lines show as bars and vice versa
                    // if (canShowGraphAsLine(config, configExtra, displayOL, mstIDsObj)) {
                    //     chartTypeItems.push("Line");
                    //     chartTypeInfo.push([SCConst.line]);
                    //     numOptions++;
                    //
                    //     if (chartTypeClient === SCConst.line) {
                    //         itemIdx = numOptions - 1;
                    //     }
                    // }

                    if (canShowGraphAsBar(configExtra, displayOL, mstIDsObj)) {
                        chartTypeItems.push("Bar");
                        chartTypeInfo.push([SCConst.bar]);
                        numOptions++;

                        if (chartTypeClient === SCConst.bar) {
                            itemIdx = numOptions - 1;
                        }
                    }

                    chartTypeItems.push("Table");
                    chartTypeInfo.push([SCConst.table]);
                    numOptions++;

                    if (chartTypeClient === SCConst.table) {
                        itemIdx = numOptions - 1;
                    }

                    chartTypeRadioGroup = (
                        <TRadioGroup
                            itemIndex={itemIdx}
                            items={chartTypeItems}
                            handleChange={this.onChartTypeRadioChange}
                            info={chartTypeInfo}
                            row={true}
                        />
                    );
                } else {
                    if (chartTypeClient === SCConst.dualAxis) {
                        itemIdx = 0;
                    } else if (chartTypeClient === SCConst.table) {
                        itemIdx = 1;
                    }

                    chartTypeRadioGroup = (
                        <TRadioGroup
                            itemIndex={itemIdx}
                            items={["Dual axis", "Table"]}
                            handleChange={this.onChartTypeRadioChange}
                            info={[[SCConst.dualAxis], [SCConst.table]]}
                            row={true}
                        />
                    );
                }
            }

            let commWithServerDialog = null;

            if (retrievingResultsBool) {
                commWithServerDialog = (
                    <TDialog
                        caption={"Communicating with server..."}
                        icon={
                            <TWifiAnimation
                                style={{
                                    marginRight: "20px",
                                    float: "left",
                                }}
                            />
                        }
                        visible={true}
                        style={{
                            width: "370px",
                        }}
                    />
                );
            }

            return (
                <div
                    style={{
                        margin: "20px",
                    }}
                >
                    {tableTitleDiv}
                    {chartOrTable}
                    {tooManySitesToShowLab}
                    {prevBtn}
                    {nextBtn}
                    {graphViewRadioGroupHeader}
                    {graphViewRadioGroup}
                    {timeIntervalComboBox}
                    {firstYearTrendComboBox}
                    {finalYearTrendComboBox}
                    {firstMonthYearComboBox}
                    {finalMonthYearComboBox}
                    {chartTypeRadioGroupHeader}
                    {chartTypeRadioGroup}
                    {demandCreationAgeGroupHeader}
                    {demandCreationAgeGroup}
                    {xAxisVarDiv}
                    {commWithServerDialog}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCResultsFormDiv"}
                    key={"SCResultsFormDiv"}
                >
                    <h3 key={"SCResultsFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCResultsForm;
